import { createScriptElement, createStylesheetElement } from "./element-helpers";

const HIGHLIGHT_STYLES_URL = 'https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.9.0/styles/default.min.css';
const HIGHLIGHT_SCRIPT_URL = 'https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.9.0/highlight.min.js';

type WindowWithSyntaxHighlighting = Window & {
  hljs?: { highlightBlock: (block: Element) => void }
};

export function setupSyntaxHighlighting() {
  document.addEventListener('DOMContentLoaded', () => {
    const codeBlocks = document.querySelectorAll('pre code');

    if (codeBlocks.length > 0) {
      const highlightStyles = createStylesheetElement(HIGHLIGHT_STYLES_URL);
      document.head.appendChild(highlightStyles);

      const highlightScript = createScriptElement(HIGHLIGHT_SCRIPT_URL);
      document.body.appendChild(highlightScript);

      highlightScript.onload = () => {
        codeBlocks.forEach((block) => {
          (window as WindowWithSyntaxHighlighting).hljs?.highlightBlock(block);
        });
      };
    }
  });
}